var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("action-sheet", {
    attrs: {
      opened: _vm.isVisible,
      keyPad: true,
      confirm: "MCOM-0000023",
      noNegativeButton: false,
      "use-top-border": false
    },
    on: {
      "update:opened": function($event) {
        _vm.isVisible = $event
      },
      cancel: _vm.hide
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isVisible,
                    expression: "isVisible"
                  }
                ],
                staticClass: "box_sckeypad_wrap active",
                attrs: { id: "box_sckeypad_wrap_socialno" }
              },
              [
                _c("div", { staticClass: "pin pin-number" }, [
                  _c("strong", { staticClass: "tit" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          /*일회용 인증번호(OTP)*/ _vm.$t("MOTP-CERTN-19")
                        ) +
                        " "
                    )
                  ]),
                  _c("p", {
                    staticClass: "desc desc-type2",
                    domProps: {
                      innerHTML: _vm._s(
                        /*인증번호 6자리를 입력하세요.*/ _vm.$t("MOTP-CERTN-20")
                      )
                    }
                  }),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(_vm._s(!_vm.getError.active ? _vm.error.errMsg : ""))
                  ]),
                  _c(
                    "ul",
                    {
                      staticClass: "pin-number--input",
                      on: {
                        click: function($event) {
                          _vm.type2 = true
                        }
                      }
                    },
                    [
                      _vm._l(6, function(data) {
                        return [
                          _c("li", { key: data }, [
                            _c("input", {
                              attrs: {
                                type: "password",
                                placeholder:
                                  _vm.textValue.length >= data ? "●" : "",
                                value: "",
                                disabled: ""
                              }
                            })
                          ])
                        ]
                      })
                    ],
                    2
                  )
                ]),
                _c(
                  "div",
                  {
                    staticClass: "inner_keypad_wrap",
                    attrs: { id: "div-extendui-password-socialno" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isVisible,
                            expression: "isVisible"
                          }
                        ],
                        staticClass: "nppfs-keypad",
                        style: _vm.makeKpdStyles(),
                        attrs: {
                          id: _vm.id,
                          "data-width": _vm.info.iw,
                          "data-height": _vm.info.ih
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            class: [
                              "kpd-wrap",
                              _vm.info.type,
                              _vm.useMultiCursor ? "kpd-multi-cursor" : ""
                            ],
                            style: _vm.makeKpdWrapStyles(),
                            on: { mousemove: _vm.onMultiCursorMove }
                          },
                          [
                            _vm.isUseAria
                              ? _c("img", {
                                  ref: _vm.info.keypadUuid + "_bg_img",
                                  staticStyle: {
                                    position: "absolute",
                                    left: "0",
                                    top: "0",
                                    border: "0px",
                                    width: "100%",
                                    height: "100%"
                                  },
                                  attrs: {
                                    src:
                                      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAMAAAAoyzS7AAADAFBMVEX///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALI7fhAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAApJREFUCJljYAAAAAIAAfRxZKYAAAAASUVORK5CYII=",
                                    alt: "키패드",
                                    id: _vm.info.keypadUuid + "_bg_img",
                                    tabindex: _vm.isUseAria ? 0 : ""
                                  }
                                })
                              : _vm._e(),
                            _vm.useMultiCursor
                              ? [
                                  _c("div", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showMultiCursorCover,
                                        expression: "showMultiCursorCover"
                                      }
                                    ],
                                    staticClass: "kpd-cover cursor-cover"
                                  }),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showMultiCursorCover,
                                          expression: "showMultiCursorCover"
                                        }
                                      ],
                                      staticClass: "kpd-cover click-cover",
                                      on: { click: _vm.onMultiCursorClick }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "click-image",
                                        attrs: {
                                          src:
                                            _vm.CONFIG.KEYPAD[
                                              "kpd-multi-cursor-image"
                                            ]
                                        }
                                      })
                                    ]
                                  ),
                                  _c("div", { staticClass: "cursor cursor1" }),
                                  _c("div", { staticClass: "cursor cursor2" })
                                ]
                              : _vm._e(),
                            _vm.info.touch && _vm.info.touch.use
                              ? [
                                  _c(
                                    "transition",
                                    {
                                      on: {
                                        "before-enter": _vm.onTouchBeforeEnter,
                                        enter: _vm.onTouchEnter,
                                        "after-enter": _vm.onTouchAfterEnter,
                                        "before-leave": _vm.onTouchBeforeLeave,
                                        leave: _vm.onTouchLeave,
                                        "after-leave": _vm.onTouchAfterLeave
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.showTouchDiv,
                                              expression: "showTouchDiv"
                                            }
                                          ],
                                          staticClass: "kpd-touch"
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "kpd-button touch1",
                                            style: _vm.makeKpdTouchStyles()
                                          }),
                                          _c("div", {
                                            staticClass: "kpd-button touch2",
                                            style: _vm.makeKpdTouchStyles()
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._l(_vm.items, function(buttonGroup, index) {
                              return [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          buttonGroup.id ===
                                          _vm.selectedButtonGroup,
                                        expression:
                                          "buttonGroup.id === selectedButtonGroup"
                                      }
                                    ],
                                    key: index,
                                    ref: "kpd-group-" + buttonGroup.id,
                                    refInFor: true,
                                    class: ["kpd-group", buttonGroup.id],
                                    style: _vm.makeKpdGroupStyles(
                                      buttonGroup,
                                      index
                                    )
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "kpd-image-button",
                                      style: _vm.makeKpdImageStyles(
                                        _vm.makeKpdImageMarginTop(buttonGroup)
                                      ),
                                      attrs: {
                                        "aria-hidden": "true",
                                        src: _vm.info.src
                                      }
                                    }),
                                    _vm._l(buttonGroup.buttons, function(
                                      button,
                                      jindex
                                    ) {
                                      return [
                                        _c("img", {
                                          key: jindex,
                                          staticClass: "kpd-data",
                                          style: _vm.makeKpdButtonStyles(
                                            button,
                                            _vm.makeKpdImageMarginTop(
                                              buttonGroup
                                            )
                                          ),
                                          attrs: {
                                            "data-action": button.action,
                                            src:
                                              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAMAAAAoyzS7AAADAFBMVEX///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALI7fhAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAApJREFUCJljYAAAAAIAAfRxZKYAAAAASUVORK5CYII=",
                                            alt: _vm.isUseAria
                                              ? _vm.buttonLabel(button)
                                              : "",
                                            "aria-label": _vm.isUseAria
                                              ? _vm.buttonLabel(button)
                                              : "",
                                            tabindex: _vm.isUseAria ? 0 : "",
                                            role: _vm.isUseAria ? "button" : ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleButtonAction(
                                                button,
                                                buttonGroup,
                                                jindex
                                              )
                                            },
                                            touch: function($event) {
                                              return _vm.handleButtonAction(
                                                button,
                                                buttonGroup,
                                                jindex
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    })
                                  ],
                                  2
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "button",
              {
                class:
                  "btn bottom " +
                  (_vm.textValue.length === 6 ? "positive" : "disabled"),
                on: { click: _vm.FN001SupplCertn }
              },
              [_vm._v(_vm._s(/*입력완료*/ _vm.$t("MCOM-0000023")))]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }